import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { searchCodeTableQuery } from '../utils/data';
import { client } from '../client';

import { Navbar, Feed, PromptDetail, CreatePrompt, Search } from '../components';

const Prompts = ({ user }) => {
  const[searchTerm, setSearchTerm] = useState('');
  const[filter, setFilter] = useState("All");
  const[sort, setSort] = useState("desc");
  let location = useLocation();
  const [aiArt, setAiArt] = useState();

  useEffect(() => {

    const aiArtGenQuery = searchCodeTableQuery("AiArtGen");

      client.fetch(aiArtGenQuery)
      .then((data) => {
        setAiArt(data);
      })

}, []);

  return (
    <div className='px-2 md:px-5'>
      <div className='bg-gray-100'>
        <Navbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} user={user} />
      </div>
      {(location.pathname.includes('/category') || location.pathname === '/') && (
      <div className='flex justify-between mb-5'>

          <select className="select select-bordered max-w-xs" onChange={(e) => {setFilter(e.target.value);}}>
          <option className="text-base border-0 outline-none capitalize bg-white text-black " value='All'>
                            All
                          </option>
                {aiArt && aiArt.map((item) => (
                          <option className="text-base border-0 outline-none capitalize bg-white text-black " value={item.name}>
                            {item.name}
                          </option>
                        ))}
          </select>

          <select className="select select-bordered max-w-xs" onChange={(e) => {setSort(e.target.value);}}>
          <option className="text-base border-0 outline-none capitalize bg-white text-black " value='desc'>
                            Newest
                          </option>
                          <option className="text-base border-0 outline-none capitalize bg-white text-black " value='asc'>
                            Oldest
                          </option>
          </select>

      </div>
      )}
      <div className='h-full'>
        <Routes>
          <Route path="/" element={<Feed filter={filter} sort={sort} />} />
          <Route path="/category/:categoryId" element={<Feed filter={filter} sort={sort} />} />
          <Route path="/prompt-detail/:promptId" element={<PromptDetail user={user} />} />
          <Route path="/create-prompt" element={<CreatePrompt user={user} />} />
          <Route path="/search" element={<Search searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
        </Routes>
      </div>
    </div>
  )
}

/*
<div className='mb-4'>
                <div className="relative">
                <select className="block appearance-none w-full bg-white border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state"
                onChange={(e) => {setFilter(e.target.value);}}>
                <option className="text-base border-0 outline-none capitalize bg-white text-black " value='All'>
                            All
                          </option>
                {AIGenType.map((item) => (
                          <option className="text-base border-0 outline-none capitalize bg-white text-black " value={item.name}>
                            {item.name}
                          </option>
                        ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
                </div>
              </div>

              <div className='mb-4'>
                <div className="relative">
                <select className="block appearance-none w-full bg-white border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state"
                onChange={(e) => {setSort(e.target.value);}}>

                          <option className="text-base border-0 outline-none capitalize bg-white text-black " value='desc'>
                            Newest
                          </option>
                          <option className="text-base border-0 outline-none capitalize bg-white text-black " value='asc'>
                            Oldest
                          </option>

                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
                </div>
              </div>

*/

export default Prompts